import React from 'react';
import { useQuery } from 'react-query';
import { RouteComponentProps, useParams } from 'react-router-dom';
import BackButton from '../../components/AppBackButton/BackButton';
import { routesURLs } from '../../Routes';
import { OnlineMockExamCourseType } from '../../services/types';
import SkeletonImageBox from '../../components/Skeletons/SkeletonImageBox';
import {getMyCourses} from "../../moduls/courses";
import { getOnlineMockExamCourses } from '../../moduls/online-mock-exam-courses';
import ButtonSelect from '../../components/AppButtonSelect/ButtonSelect';
import Icon from '../../components/AppIcon/Icon';

const OnlineMockExamCoursesList: React.FC<RouteComponentProps> = (props) => {
    const { data: myCourses } = useQuery<any>('my-courses', getMyCourses);

    const { data: courses = [], isFetched } = useQuery<OnlineMockExamCourseType[]>(
        ['online-mock-exam-courses'],
        getOnlineMockExamCourses,
        {
            staleTime: Infinity,
        }
    );

    function hasAllLessonsInCourse(courseId: any) {
        for (var l = 0; l < myCourses?.online_mock_exam_courses.length; l++) {
            let course = myCourses?.online_mock_exam_courses[l];

            if (course.id === courseId) {
                return myCourses?.online_mock_exam_courses[l]?.hasAllLessons;
            }
        }
    }

    return (
        <>
            <div className="page-row">
                <h1 className="h-text-center h-mb-175">
                    On-line přijímačky nanečisto
                </h1>
                {courses.length > 0 && (
                    <h3 className="h-text-center">Vyberte kurz</h3>
                )}
                <div className="container-row center-md">
                    {isFetched ? (
                        courses.length > 0 ? (
                            courses.map((courseItem) => (
                                <ButtonSelect
                                    key={courseItem.id}
                                    onClick={() => props.history.push(`${routesURLs.onlineMockExamCourses}/${courseItem.id}`)}
                                    rightPart={<Icon icon="chevron-right-gray" width=".875rem" height=".875rem" />}
                                    isDisabled={hasAllLessonsInCourse(courseItem.id)}
                                    tooltip={hasAllLessonsInCourse(courseItem.id) ? 'KURZ JE DOSTUPNÝ VE VAŠÍ OSOBNÍ ZÓNĚ' : ''}
                                >
                                    {courseItem.name}
                                </ButtonSelect>
                            ))
                        ) : <p className="h-text-center">Všechny aktivní kurzy máte již zakoupené.</p>
                    ) : <Loader />}
                </div>
            </div>
            <BackButton />
        </>
    );
};

const Loader = () => (
    <>
        <div className="col-md-4">
            <SkeletonImageBox />
        </div>
        <div className="col-md-4">
            <SkeletonImageBox />
        </div>
        <div className="col-md-4">
            <SkeletonImageBox />
        </div>
    </>
);

export default OnlineMockExamCoursesList;
